import * as React from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import {
  Card,
  CardContent,
  Collapse,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Terms from "./groups/Terms";
import { Confirm, Edit, useGetRecordId, useRecordContext } from "react-admin";
import { Link } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";
import CustomBox from "../unit/CustomBox";
import CustomTabButton from "../unit/CustomTabButton";
import useNotify from "../unit/useNotify";
import AddOns from "./groups/AddOns";
import Alerts from "./groups/Alerts";
import Authorization from "./groups/Authorization";
import AuthorizationClosing from "./groups/AuthorizationClosing";
import AuthorizationDisbursement from "./groups/AuthorizationDisbursement";
import AuthorizationRepayment from "./groups/AuthorizationPayment";
import AutoRemoval from "./groups/AutoRemoval";
import Calculation from "./groups/Calculation";
import Collateral from "./groups/Collateral";
import Community from "./groups/Community";
import CouponCode from "./groups/CouponCode";
import DataFields from "./groups/DataFields";
import Disclosures from "./groups/Disclosures";
import Documents from "./groups/Documents";
import Employer from "./groups/Employer";
import ESignature from "./groups/ESignature";
import Fees from "./groups/Fees";
import LandingPage from "./groups/LandingPage";
import Partnership from "./groups/Partnership";
import Preunderwriting from "./groups/Preunderwriting";
import Process from "./groups/Process";
import PurchaseInfo from "./groups/PurchaseInfo";
import Purpose from "./groups/Purpose";
import Referral from "./groups/Referral";
import ScoreCard from "./groups/ScoreCard";
import Servicing from "./groups/Servicing";
import Timeline from "./groups/Timeline";
import Underwriting from "./groups/Underwriting";
import UploadDocs from "./groups/UploadDocs";
import Vendor from "./groups/Vendor";
import { hmLightTheme } from "../themes/hmTheme";
import Chip from "@mui/material/Chip";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { ExpandMore } from "@mui/icons-material";
import ArrowCircleLeftSharpIcon from "@mui/icons-material/ArrowCircleLeftSharp";
import ServicingRepayment from "./groups/ServicingRepayment";
import { useRefresh } from "react-admin";
import DescriptionEn from "./groups/DescriptionEn";
import DescriptionEs from "./groups/DescriptionEs";
import DescriptionPs from "./groups/DescriptionPs";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CircleIcon from "@mui/icons-material/Circle";
import SwitchOnIcon from "../unit/svgIcon/SwitchOnIcon";
import SwitchIcon from "../unit/svgIcon/SwitchIcon";
const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "white";
  let textColor = "#000";

  return (
    <Box sx={{ width: "100%" }}>
      {type}
      <Chip
        component="span"
        label={appCounts}
        size="small"
        className="numericText"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      />
    </Box>
  );
};
const PRODUCT_LEFT_MENUS = [
  {
    id: "Description",
    label: "Description",
    children: [
      { id: "linkto_english", label: "English" },
      { id: "linkto_spanish", label: "Spanish" },
      { id: "linkto_pashto", label: "Pashto" },
    ],
  },
  {
    id: "Attributes",
    label: "Attributes",
    children: [
      { id: "linkto_loanterms", label: "Terms" },
      { id: "linkto_calculation", label: "Calculation" },
      { id: "linkto_fees", label: "Fees" },
      { id: "linkto_loanpurpose", label: "Permitted Purposes" },
      { id: "linkto_addones", label: "Add-Ons" },
    ],
  },
  {
    id: "Application",
    label: "Application",
    children: [
      { id: "linkto_applicant", label: "Data to Collect" },
      { id: "linkto_upload", label: "Documents to Upload" },
      { id: "linkto_autoremoval", label: "Auto Removal" },
      { id: "linkto_purchaseinfo", label: "Purchase Finance" },
      { id: "linkto_community", label: "Community" },
    ],
  },
  {
    id: "Review",
    label: "Review",
    children: [
      { id: "linkto_underwriting", label: "Requirements" },
      { id: "linkto_process", label: "Process" },
      { id: "linkto_timeline", label: "Timeline" },
      { id: "linkto_referral", label: "Referral" },
      // { id: "linkto_underwriting", label: "Underwriting" },
      // { id: "linkto_preunderwriting", label: "Pre-Underwriting" },
      { id: "linkto_preunderwriting", label: "Screening" },
    ],
  },
  {
    id: "documentation",
    label: "Documentation",
    children: [
      { id: "Document Templates", label: "Document Templates" },
      { id: "E-Signature", label: "E-Signature" },
    ],
  },
  {
    id: "Servicing",
    label: "Servicing",
    children: [
      { id: "linkto_servicing_disbursement", label: "Disbursement" },
      { id: "linkto_servicing_repayment", label: "Repayment" },
    ],
  },
  // {
  //   id: "E-Signature",
  //   label: "E-Signature",
  //   children: [],
  // },
  {
    id: "Legal & Compliance",
    label: "Legal Notices",
    children: [
      {
        id: "linkto_authorization_application",
        label: "Consent for Application",
      },
      { id: "linkto_authorization_closing", label: "Consent for Closing" },
      { id: "linkto_authorization_payment", label: "Consent for Payment" },
      {
        id: "linkto_authorization_disbursement",
        label: "Consent for Disbursement",
      },
      { id: "linkto_disclosure", label: "Disclosures" },
      // show tabls
    ],
  },
];

const PRODUCT_MENU_MAP = {
  linkto_english: "description_en",
  linkto_spanish: "description_es",
  linkto_pashto: "description_ps",
  linkto_loanterms: "terms",
  linkto_calculation: "calculation",
  linkto_fees: "fees",
  linkto_loanpurpose: "purpose",
  linkto_addones: "addons",
  linkto_applicant: "datafields",
  linkto_upload: "uploaddocs",
  linkto_process: "process",
  linkto_timeline: "timeline",
  linkto_underwriting: "underwriting",
  linkto_preunderwriting: "preunderwriting",
  linkto_servicing_disbursement: "servicing_disbursement",
  linkto_servicing_repayment: "servicing_repayment",
  linkto_authorization_application: "authorization_application",
  linkto_authorization_closing: "authorization_closing",
  linkto_authorization_payment: "authorization_payment",
  linkto_authorization_disbursement: "authorization_disbursement",
  linkto_disclosure: "disclosures",
  linkto_autoremoval: "autoRemoval",
  linkto_referral: "referral",
  "E-Signature": "esignature",
  "Document Templates": "templates",
};

const getMappedMenuId = (menuId: string) => {
  if (menuId in PRODUCT_MENU_MAP) {
    return PRODUCT_MENU_MAP[menuId as keyof typeof PRODUCT_MENU_MAP];
  }
  return menuId;
};

const findMenuLabel = (menuId: string) => {
  // console.log("findMenuLabel menuId ====》 ", menuId);
  for (const menu of PRODUCT_LEFT_MENUS) {
    if (menu.id === menuId) {
      return menu.label;
    }
    if (menu.children && menu.children.length > 0) {
      for (const child of menu.children) {
        if (child.id === "linkto_" + menuId) {
          return child.label;
        }
      }
    }
  }
  if (menuId == "autoremoval") {
    return "Auto Removal";
  } else if (menuId == "referral") {
    return "Referral";
  }
};

const ProductHeaderTitle = () => {
  const record = useRecordContext();
  const { successNotify, errorNotify } = useNotify();
  const productId = record?.data?.basic?.id;
  const productType = record?.data?.basic?.type;
  const productSubType = record?.data?.basic?.subType;

  const productDivision = record?.data?.basic?.division;

  let productSubTypeName = "";
  if (productSubType == "start") {
    productSubTypeName = "Small and Simple";
  } else if (productSubType == "employee") {
    productSubTypeName = "Employment Based";
  } else if (productSubType == "general") {
    productSubTypeName = "General Purpose";
  } else if (productSubType == "builder") {
    productSubTypeName = "Single Term";
  } else if (productSubType == "mortgage") {
    productSubTypeName = "Own A Home";
  } else if (productSubType == "car") {
    productSubTypeName = "Purchase Car Loan";
  } else if (productSubType == "account") {
    productSubTypeName = "Depository Account";
  } else if (productSubType == "refund") {
    productSubTypeName = "Refund Anticipation";
  } else if (productSubType == "refinancecar") {
    productSubTypeName = "Refinance Car Loan";
  } else if (productSubType == "buildingladder") {
    productSubTypeName = "Credit Building Ladder";
  } else if (productSubType == "securedcreditcard") {
    productSubTypeName = "Secured Credit Card";
  } else if (productSubType == "micro") {
    productSubTypeName = "Micro Loan";
  } else if (productSubType == "depositoryaccount") {
    productSubTypeName = "Depository Account";
  } else if (productSubType == "realestate") {
    productSubTypeName = "Commercial Real Estate";
  } else if (productSubType == "vehicle") {
    productSubTypeName = "Business Vehicle";
  } else if (productSubType == "smallmicro") {
    productSubTypeName = "Micro Loan";
  } else if (productSubType == "purchase") {
    productSubTypeName = "Purchase Finance";
  } else {
    productSubTypeName = productSubType || "";
  }

  let productTypeName = "";
  if (productType == "unsecured") {
    productTypeName = "Unsecured Loan";
  } else if (productType == "secured") {
    productTypeName = "Secured Loan";
  } else if (productType == "builder") {
    productTypeName = "Credit Builder Loan";
  } else if (productType == "revolvingcredit") {
    productTypeName = "Revolving Credit";
  } else if (productType == "smallbusiness") {
    productTypeName = "Small Business Loan";
  } else if (productType == "account") {
    productTypeName = "Account Opening";
  } else {
    productTypeName = productType || "";
  }

  const handleChangeStatus = () => {
    let newStatus = record?.data?.basic?.status == 1 ? 0 : 1; // Toggle status

    // Update the record status in the database
    var reqUrl = "products/actions/changeStatus";
    var response = sendRequest(reqUrl, {
      id: record?.data?.basic?.id,
      data: {
        status: newStatus,
      },
    });
    response
      .then((res) => {
        if (res.code == 200) {
          successNotify("Status changed successfully");
        } else {
          errorNotify("Failed to change status! " + res?.message);
        }
      })
      .catch((error) => {
        errorNotify("Error changing status: " + error.message);
      });
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "1em",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: "1.125rem",
            color: "gray",
            fontWeight: "bold",
            mb: 0,
          }}
        >
          {productTypeName ? (
            <>
              {productTypeName}
              <span> / </span>
              {/* <br /> */}
            </>
          ) : (
            ""
          )}
          {productSubTypeName ? (
            <>
              {productSubTypeName}
              <span> / </span>
              {/* <br /> */}
            </>
          ) : (
            ""
          )}
          {`Product ID: ${productId}`}
        </Typography>

        <Box
          sx={{
            marginLeft: "auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {record?.data?.basic?.status == "1" ? (
            <span
              style={{
                color: "#2e7d32",
                fontWeight: "bold",
                fontSize: "0.875rem",
              }}
            >
              Active
            </span>
          ) : (
            <span
              style={{
                color: "#c62828",
                fontWeight: "bold",
                fontSize: "0.875rem",
              }}
            >
              Inactive
            </span>
          )}
          <Tooltip
            title={
              `` +
              (record?.data?.basic?.status == 1 ? "Deactivate" : "Activate") +
              ` product`
            }
            placement="left"
          >
            <IconButton onClick={handleChangeStatus} sx={{ ml: "4px" }}>
              {record?.data?.basic?.status == 1 ? (
                <SwitchOnIcon color="red" size="32px" />
              ) : (
                <SwitchIcon color="green" size="32px" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </>
  );
};

const ProductCustomMenu = ({ ...props }) => {
  const record = useRecordContext();
  const leftMenus = record?.data?.basic?.productMenus;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;
  const menuDirtyArray = props?.menuDirtyArray || [];
  type MenuItem = {
    id: string;
    label: string;
    children?: MenuItem[];
  };

  const [productLeftMenus, setProductLeftMenus] =
    React.useState<MenuItem[]>(PRODUCT_LEFT_MENUS);
  const [openItems, setOpenItems] = React.useState<{ [key: string]: boolean }>(
    {}
  );
  // console.log("==================>>>>>", record?.data?.basic?.haveContentMenu);
  const [haveContentMenu, setHaveContentMenu] = React.useState<string[]>(
    record?.data?.basic?.haveContentMenu
  );

  // const [selectedItem, setSelectedItem] = React.useState<string>("Description");
  const [selectedItem, setSelectedItem] =
    React.useState<string>("linkto_english");

  // Confirm 对话框状态
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [pendingMenuItem, setPendingMenuItem] = React.useState<{
    id: string;
    hasChildren: boolean;
  } | null>(null);

  //当record变化时，更新haveContentMenu状态
  React.useEffect(() => {
    setHaveContentMenu(record?.data?.basic?.haveContentMenu || []);
  }, [record]);

  // 默认展开所有菜单
  React.useEffect(() => {
    const initialOpenState = productLeftMenus.reduce((acc, menu) => {
      acc[menu.id] = true;
      return acc;
    }, {} as { [key: string]: boolean });
    setOpenItems(initialOpenState);
  }, []);

  // 处理确认切换
  const handleConfirmSwitch = () => {
    if (pendingMenuItem) {
      // 通知父组件取消当前菜单的 dirty 状态
      props?.handleCancelDirty?.(selectedItem, false);

      // 执行菜单切换
      if (pendingMenuItem.hasChildren) {
        setOpenItems((prev) => ({
          ...prev,
          [pendingMenuItem.id]: !prev[pendingMenuItem.id],
        }));
        // refresh();
      } else {
        handleItemSelect(pendingMenuItem.id);
      }
    }
    setConfirmOpen(false);
    setPendingMenuItem(null);
  };

  const handleCancelSwitch = () => {
    setConfirmOpen(false);
    setPendingMenuItem(null);
  };

  // 处理一级菜单点击
  const handleParentClick = (itemId: string, hasChildren: boolean) => {
    // 检查当前选中的菜单是否有未保存的修改
    const currentDirtyItem = menuDirtyArray.find(
      (item: any) => item.menu === selectedItem && item.dirty
    );

    // 如果点击的是同一个菜单，或者没有未保存的修改，直接执行操作
    if (itemId === selectedItem || !currentDirtyItem) {
      if (hasChildren) {
        setOpenItems((prev) => ({
          ...prev,
          [itemId]: !prev[itemId],
        }));
      } else {
        handleItemSelect(itemId);
      }
      return;
    }

    // 如果有未保存的修改，显示确认对话框
    setPendingMenuItem({ id: itemId, hasChildren });
    setConfirmOpen(true);
  };

  // 处理菜单项选择
  const handleItemSelect = (itemId: string) => {
    setSelectedItem(itemId);
    props.onItemSelected?.(itemId);
    props.cb?.(itemId);
  };

  // 检查菜单是否有未保存的修改
  const isMenuDirty = (menuId: string) => {
    return menuDirtyArray.some(
      (item: any) => item.menu === menuId && item.dirty
    );
  };

  const renderMenuItem = (menu: MenuItem, isChild: boolean = false) => {
    const hasChildren = Boolean(menu.children && menu.children.length > 0);
    const isOpen = openItems[menu.id];
    const isSelected = selectedItem === menu.id;
    const isDirty = isMenuDirty(menu.id);

    if (
      menu.id == "linkto_addones" &&
      !productModulesGroup?.includes("product-addons")
    ) {
      return null;
    }
    if (
      menu.id == "linkto_purchaseinfo" &&
      !productModulesGroup?.includes("purchaseinfo")
    ) {
      return null;
    }
    if (
      menu.id == "linkto_loanpurpose" &&
      !productModulesGroup?.includes("credit_purpose") &&
      !productModulesGroup?.includes("purpose_general") &&
      !productModulesGroup?.includes("designated_purchase")
    ) {
      return null;
    }

    return (
      <Box key={menu.id} sx={{ width: "100%" }}>
        {/* {menu.id}---- */}
        {/* 自定义按钮，替代 ListItemButton */}
        <Box
          onClick={() => handleParentClick(menu.id, hasChildren)}
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: "0px 5px 0px 5px",
            pl: isChild ? "40px" : "0px",
            cursor: "pointer",
            backgroundColor: isSelected ? "#1976d233" : "transparent",
            transition: "background-color 0.2s",
            "&:hover": {
              backgroundColor: "#1976d220",
            },
            ...(!hasChildren &&
              !isChild && {
                "& .menu-label": {
                  fontWeight: 500,
                },
              }),
          }}
        >
          {/* 自定义文本，替代 ListItemText */}
          <Box
            className="menu-label"
            sx={{
              fontFamily: "Proxima Nova",
              padding: "5px 0.2em 5px 0.2em",
              fontSize: "1rem",
              fontWeight: isChild ? 400 : 500,
              color: isSelected ? "#000" : "gray",
              borderLeft: "none",
              paddingLeft: "10px",
              flex: 1,
            }}
          >
            {/* 如果haveContentMenu中含有menu.id，menu.id 需要用PRODUCT_MENU_MAP 转换下， 入有则显示已填入过信息的状态 */}
            {!hasChildren && (
              <>
                {haveContentMenu &&
                haveContentMenu.includes(getMappedMenuId(menu.id)) ? (
                  <CheckCircleOutlineIcon
                    sx={{
                      fontSize: "0.875rem",
                      color: "green",
                      verticalAlign: "middle",
                      mr: 1,
                      mt: -1.1,
                    }}
                  />
                ) : (
                  <RadioButtonUncheckedIcon
                    fontSize="small"
                    sx={{
                      fontSize: "0.875rem",
                      color: "gray",
                      verticalAlign: "middle",
                      mr: 1,
                      mt: -1.1,
                    }}
                  />
                )}
              </>
            )}
            {/* {menu.id}---{PRODUCT_MENU_MAP[menu.id]}--- */}
            {menu.label}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {/* 展开/折叠图标 */}
            {hasChildren && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {isOpen ? <ExpandLess /> : <ExpandMore />}
              </Box>
            )}

            {/* 修改状态星号 */}
            {isDirty && (
              <Chip
                label="*"
                sx={{
                  backgroundColor: "transparent",
                  color: "red",
                  borderColor: "transparent",
                  borderWidth: 0,
                  borderStyle: "solid",
                  padding: 0,
                  minWidth: "auto",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                }}
              />
            )}
          </Box>
        </Box>
        {/* 渲染子菜单 */}
        {hasChildren && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box sx={{ width: "100%" }}>
              {menu.children?.map((child) => renderMenuItem(child, true))}
            </Box>
          </Collapse>
        )}
      </Box>
    );
  };
  return (
    <>
      {/* Confirm 对话框放在组件顶层 */}
      <Confirm
        isOpen={confirmOpen}
        title="Unsaved Changes"
        content="You have unsaved changes. Switching to another section will discard these changes. Do you want to continue?"
        onConfirm={handleConfirmSwitch}
        onClose={handleCancelSwitch}
        confirm="Discard Changes"
        cancel="Stay Here"
        maxWidth="xs"
        sx={{
          "& .MuiButton-root.RaConfirm-confirmPrimary": {
            width: "auto",
            backgroundColor: "primary.main",
            color: "#fff",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
          "& .MuiButton-root": {
            width: "120px",
            color: "#1976d2",
            bgcolor: "#e0e0e0",
            "&:hover": {
              bgcolor: "#f5f5f5",
            },
          },
          "& .MuiDialogTitle-root": {
            fontWeight: 700,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          },
          "& .MuiDialogContent-root": {
            // 内容样式
            paddingTop: 3,
            paddingBottom: 3,
            fontSize: "1rem",
          },
          "& .MuiDialogContentText-root": {
            color: "black",
            fontSize: "0.875rem",
            fontFamily: "Proxima Nova",
            mt: "10px",
          },
          "& .MuiDialogActions-root": {
            // 按钮容器样式 - 两端对齐
            padding: 2,
            paddingTop: 0,
            justifyContent: "space-between",
            "& .MuiButton-root": {
              minWidth: 120,
              // 移除图标
              "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                display: "none",
              },
            },
          },
        }}
      />

      <Box
        sx={{
          minHeight: 352,
          width: "100%",
          overflow: "auto",
        }}
        id="product-menu-custom"
      >
        <div
          // component="nav"
          style={{
            padding: 0,
          }}
        >
          {productLeftMenus.map((menu) => renderMenuItem(menu, false))}
        </div>
      </Box>
    </>
  );
};
const ProductBackLink = () => {
  const record = useRecordContext();
  const productId = record?.data?.basic?.id;
  return (
    <>
      <Link
        to={`/products?filter={"status":${record?.data?.basic?.type},"filerLoanTypeId":${record?.data?.basic?.iProductTypeId}}`}
        style={{ float: "left", marginTop: "-30px" }}
      >
        <Tooltip title="Return to Product List" placement="left">
          <ArrowCircleLeftSharpIcon
            color="primary"
            style={{ float: "right", transform: "rotate(0deg)" }}
          />
        </Tooltip>
      </Link>
    </>
  );
};

const ProductEdit = ({ ...props }) => {
  const [rightTabs, setRightTabs] = React.useState<any[]>([]);
  const [activeTab, setActiveTab] = React.useState(0);
  const [selectedItem, setSelectedItem] = React.useState("Description");
  const [selectSubItem, setSelectSubItem] = React.useState("linkto_english");
  const [menuDirtyArray, setMenuDirtyArray] = React.useState<any[]>([]); // {menu: string, dirty: boolean}
  const { success, error } = useNotify();
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const refresh = useRefresh();
  const pId = useGetRecordId();
  const scrollToSection = (sectionId: string) => {
    setSelectedItem(sectionId);
    setActiveTab(0);
    // setSelectSubItem("linkto_" + rightTabs[0]?.id);
  };
  const scrollToSubSection = (subSectionId: string) => {
    const element = document.getElementById(subSectionId);
    if (element) {
    }
  };
  // const record = useRecordContext();

  const handleSaveForm = async (data: any, curMenu: string) => {
    // console.log("handleSaveForm data:", data);
    const reqUrl = "products/actions/edit";
    let submitData = {};
    // if (data?.saveAction == "description") {
    if (data?.saveAction == "description_en") {
      submitData = {
        saveAction: data?.saveAction,
        productname_en: data?.productname_en,
        description_en: data?.description_en,
      };
    } else if (data?.saveAction == "description_es") {
      submitData = {
        saveAction: data?.saveAction,
        productname_es: data?.productname_es,
        description_es: data?.description_es,
      };
    } else if (data?.saveAction == "description_ps") {
      submitData = {
        saveAction: data?.saveAction,
        productname_ps: data?.productname_ps,
        description_ps: data?.description_ps,
      };
    } else if (data?.saveAction == "calculation") {
      submitData = {
        saveAction: data?.saveAction,
        day_count_convention: data?.day_count_convention,
        cal_loan_terms: data?.cal_loan_terms,
        interest_accrual_method: data?.interest_accrual_method,
        sPaymentMethod: data?.sPaymentMethod,
        sInterestOnlyMonths: data?.sInterestOnlyMonths,
        sPaymentRounding: data?.sPaymentRounding,
      };
    } else if (data?.saveAction == "fees") {
      submitData = {
        saveAction: data?.saveAction,
        applicationFee: data?.applicationFee,
        applicationFeeUnit: data?.applicationFeeUnit,
        sChargeTime: data?.sChargeTime,
        sChargeMethod: data?.sChargeMethod,
        originationFee: data?.originationFee,
        originationFeeUnit: data?.originationFeeUnit,
        iEmploymentCheckFee: data?.iEmploymentCheckFee,
        iCreditCheckFee: data?.iCreditCheckFee,
      };
    } else {
      submitData = data;
    }
    // console.log("Check =====> submitData", submitData);

    // console.log("=====>>>>save form data ===>curMenu ===>", curMenu);
    if (submitData) {
      // success("Saving data..." + JSON.stringify(submitData, null, 2));
      const res = await sendRequest(reqUrl, { id: pId, data: submitData });
      if (res?.code == 200) {
        success("Saved successfully");
        //保存成功后，更新menuDirtyArray状态，设置当前菜单为未修改状态
        setMenuDirtyArray((prev: any) => {
          const newArray = prev.filter((item: any) => item.menu !== curMenu);
          return newArray;
        });
        //保存成功后， 要刷新数据，重新获取菜单数据和内容数据
        refresh();
      } else {
        error("Error saving " + res?.message);
      }
      return res;
    } else {
      error("Error saving description: No data to save");
      return null;
    }
  };

  const ShowRightTabs = (props: any) => {
    const record = useRecordContext();
    const leftMenus = record?.data?.basic?.productMenus;
    const selectItem = props?.selectedItem?.replace("linkto_", "");
    const [changeItemId, setChangeItemId] = React.useState("");
    const [changeItemTabIndex, setChangeItemTabIndex] = React.useState(0);
    // console.log("ShowRightTabs props====>", selectItem);
    const rightTabs: { id: any; label: any; children: never[] }[] = [];

    //if rightTabs no have item, will use default tab
    if (rightTabs.length == 0) {
      rightTabs.push({
        id: selectItem,
        label: findMenuLabel(selectItem) || selectItem,
        children: [],
      });
    }

    const handelTabMenuChange = (subItemId: string, tabIndex: number) => {
      setSelectSubItem(subItemId);
      setActiveTab(tabIndex);
    };

    return (
      <>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "#00ccb1",
            // borderColor: "#1976d2",
          }}
        >
          {rightTabs.map((tab) => (
            <CustomTabButton
              key={tab.id}
              id={"product_edit_tab_" + tab.id}
              variant="text"
              onClick={() => {
                // setSelectSubItem("linkto_" + tab.id);
                // setActiveTab(rightTabs.indexOf(tab));
                // alert("tab click " + tab.id);
                // alert("tab click index " + rightTabs.indexOf(tab));
                setChangeItemId(tab.id);
                setChangeItemTabIndex(rightTabs.indexOf(tab));
                handelTabMenuChange("linkto_" + tab.id, rightTabs.indexOf(tab));
              }}
              className={
                activeTab === rightTabs.indexOf(tab) ? "Mui-selected" : ""
              }
              sx={{
                "&.MuiButton-root.Mui-selected": {
                  background: "#edf4fb",
                  // borderLeft: "5px solid #00ccb1",
                  // borderLeft: "5px solid #1976d233",
                  color: "#000",
                },
              }}
            >
              {tab.label}
              {/* ----- {tab?.id} */}
            </CustomTabButton>
          ))}
        </Box>
      </>
    );
  };

  const handleChangeMenu = (itemId: string) => {
    // console.log("handleChangeMenu itemId xxxxx:", itemId, activeTab);
    let defaultSubItem = "linkto_english";
    if (itemId == "Description") {
      defaultSubItem = "linkto_english";
    } else if (itemId == "Document Templates") {
      defaultSubItem = "linkto_loan_docs";
    } else if (itemId == "E-Signature") {
      defaultSubItem = "linkto_esign";
    } else if (itemId == "Attributes") {
      defaultSubItem = "linkto_loanterms";
    } else if (itemId == "Application") {
      defaultSubItem = "linkto_community";
    } else if (itemId == "Review") {
      defaultSubItem = "linkto_process";
    } else if (itemId == "Servicing") {
      defaultSubItem = "linkto_servicing_disbursement";
    } else if (itemId == "Legal & Compliance") {
      defaultSubItem = "linkto_authorization_application";
    } else if (itemId == "Marketing") {
      defaultSubItem = "linkto_landing";
    } else {
      defaultSubItem = itemId;
    }
    console.log("handleChangeMenu defaultSubItem:", defaultSubItem);
    setSelectSubItem(defaultSubItem);
    setActiveTab(0);
  };

  const handleDirtyChange = (curMenu: string, dirty: any) => {
    // console.log(
    //   "handle isDirty Change=====>: ",
    //   curMenu,
    //   dirty ? "dirty" : "not dirty"
    // );
    setMenuDirtyArray((prev) => {
      const newArray = [...prev];
      const index = newArray.findIndex((item) => item.menu === curMenu);
      if (index !== -1) {
        newArray[index].dirty = dirty;
      } else {
        newArray.push({ menu: curMenu, dirty });
      }
      return newArray;
    });
    // if (dirty) {
  };
  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        {/* <div>
          {menuDirtyArray.map((item) => (
            <div key={item.menu}>
              {item.menu} --- {item.dirty ? "Dirty" : "Not Dirty"}
            </div>
          ))}
        </div> */}
        <Edit
          {...props}
          id={pId}
          basePath="/products"
          resource="products"
          className="products_edit_dialog_form"
          sx={{
            width: "100%",
            height: "100%",
            background: "#fff",
            border: "none",
            borderRadius: "0px",
            "& .MuiCard-root": {
              border: "none",
              background: "#f8f9f9",
            },
          }}
          loading={<div>Loading...</div>}
        >
          <ProductHeaderTitle />
          <Grid container columnSpacing={2} sx={{ mb: 0 }}>
            {/* <Grid item sx={{ flexShrink: 0, mb: 0 }}> */}
            <Grid item sx={{ width: 320, flexShrink: 0, mb: 0 }}>
              <Box
                sx={{
                  display: "block",
                  border: "1px solid #e0e0e3",
                  // borderRadius: "10px",
                  padding: "8px",
                  backgroundColor: "#f8f9f9",
                  // backgroundColor: "red",
                  height: "calc(100vh - 130px)",
                  overflowY: "auto",
                }}
              >
                <ProductCustomMenu
                  onItemSelected={scrollToSection}
                  selectedItem={selectedItem}
                  cb={handleChangeMenu}
                  menuDirtyArray={menuDirtyArray}
                  handleCancelDirty={handleDirtyChange}
                />
              </Box>
            </Grid>

            <Grid
              item
              xs
              sx={{
                flex: "1 1 auto",
                minWidth: 0,
                "& .MuiGrid-item": { fontSize: "14px" },
                scrollMarginTop: "0px",
              }}
            >
              {/* remove Right Tab */}
              {/* <Box
                sx={{
                  display: "block",
                  padding: "8px",
                  height: "50px",
                }}
              >
                <ShowRightTabs
                  selectedItem={
                    selectedItem == "Description"
                      ? "linkto_english"
                      : selectedItem
                  }
                  handleCancelDirty={handleDirtyChange}
                />
              </Box> */}
              {/* {selectedItem}----selectSubItem: {selectSubItem}----activeTab: */}
              {/* {activeTab} */}
              <Box
                sx={{
                  display: "block",
                  border: "1px solid #e0e0e3",
                  mt: "0px",
                  // borderRadius: "10px",
                  padding: "8px",
                  paddingTop: "15px",
                  backgroundColor: "#fff",
                  // height: "calc(100vh - 158px)",
                  // height: "calc(100vh - 188px)",
                  height: "calc(100vh - 130px)",
                }}
              >
                {/* Description */}

                {/* {(selectSubItem == "linkto_productinfo" ||
                  selectSubItem == "linkto_english" ||
                  selectSubItem == "linkto_spanish" ||
                  selectSubItem == "linkto_pashto") && (
                  <CustomBox id="linkto_productinfo">
                    <Description
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      selectLanguage={selectSubItem}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )} */}
                {selectSubItem == "linkto_english" && (
                  <CustomBox id="linkto_english">
                    <DescriptionEn
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      selectLanguage={selectSubItem}
                      curMenu={"linkto_english"}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {selectSubItem == "linkto_spanish" && (
                  <CustomBox id="linkto_spanish">
                    <DescriptionEs
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      selectLanguage={selectSubItem}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {selectSubItem == "linkto_pashto" && (
                  <CustomBox id="linkto_pashto">
                    <DescriptionPs
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      selectLanguage={selectSubItem}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {/* Attributes */}

                {selectSubItem == "linkto_loanterms" && (
                  <CustomBox id="linkto_loanterms">
                    <Terms
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {/* Calculation */}

                {selectSubItem == "linkto_calculation" && (
                  <CustomBox id="linkto_calculation">
                    <Calculation
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{
                        day_count_convention: "Actual/360",
                        // 其他默认值...
                      }}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {/* Fees */}

                {selectSubItem == "linkto_fees" && (
                  <CustomBox id="linkto_fees">
                    <Fees
                      {...props}
                      id="fees"
                      onSave={handleSaveForm}
                      defaultValues={
                        {
                          // 其他默认值...
                        }
                      }
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {/* Purpose */}

                {selectSubItem == "linkto_loanpurpose" && (
                  <CustomBox id="linkto_loanpurpose">
                    <Purpose
                      {...props}
                      id="purpose"
                      onSave={handleSaveForm}
                      defaultValues={
                        {
                          // 其他默认值...
                        }
                      }
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {/* Add-Ons  */}

                {selectSubItem == "linkto_addones" && (
                  <CustomBox id="linkto_addones">
                    <AddOns
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={
                        {
                          // 其他默认值...
                        }
                      }
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {/* Product Type */}

                {/* Application */}

                {selectSubItem == "linkto_employer" && (
                  <CustomBox id="linkto_employer">
                    <Employer
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_purchaseinfo" && (
                  <CustomBox id="linkto_purchaseinfo">
                    <PurchaseInfo
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_vendors" && (
                  <CustomBox id="linkto_vendors">
                    <Vendor
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_community" && (
                  <CustomBox id="linkto_community">
                    <Community
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_collateral" && (
                  <CustomBox id="linkto_collateral">
                    <Collateral
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_applicant" && (
                  <CustomBox id="linkto_applicant">
                    <DataFields
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_upload" && (
                  <CustomBox id="linkto_upload">
                    <UploadDocs
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {/* Review */}

                {selectSubItem == "linkto_process" && (
                  <CustomBox id="linkto_process">
                    <Process
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_timeline" && (
                  <CustomBox id="linkto_timeline">
                    <Timeline
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_preunderwriting" && (
                  <CustomBox id="linkto_preunderwriting">
                    <Preunderwriting
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_underwriting" && (
                  <CustomBox id="linkto_underwriting">
                    <Underwriting
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_workflow" && (
                  <CustomBox id="linkto_workflow">
                    <Alerts
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_underwriting_score_card" && (
                  <CustomBox id="linkto_underwriting_score_card">
                    <ScoreCard
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {/* Servicing */}

                {selectSubItem == "linkto_servicing_disbursement" && (
                  <CustomBox id="linkto_servicing_disbursement">
                    <Servicing
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}
                {selectSubItem == "linkto_servicing_repayment" && (
                  <CustomBox id="linkto_servicing_repayment">
                    <ServicingRepayment
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {/* Legal & Compliance */}

                {selectSubItem == "linkto_authorization_application" && (
                  <CustomBox id="linkto_authorization_application">
                    <Authorization
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_authorization_closing" && (
                  <CustomBox id="linkto_authorization_closing">
                    <AuthorizationClosing
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_authorization_payment" && (
                  <CustomBox id="linkto_authorization_payment">
                    <AuthorizationRepayment
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_authorization_disbursement" && (
                  <CustomBox id="linkto_authorization_disbursement">
                    <AuthorizationDisbursement
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_disclosure" && (
                  <CustomBox id="linkto_disclosure">
                    <Disclosures
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_loan_docs" && (
                  <CustomBox id="linkto_loan_docs">
                    <Documents
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_esign" && (
                  <CustomBox id="linkto_esign">
                    <ESignature
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_autoremoval" && (
                  <CustomBox id="linkto_autoremoval">
                    <AutoRemoval
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />{" "}
                  </CustomBox>
                )}

                {/* Marketing */}

                {selectSubItem == "linkto_referral" && (
                  <CustomBox id="linkto_referral">
                    <Referral
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_partners" && (
                  <CustomBox id="linkto_partners">
                    <Partnership
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_landing" && (
                  <CustomBox id="linkto_landing">
                    <LandingPage
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {selectSubItem == "linkto_couponcode" && (
                  <CustomBox id="linkto_couponcode">
                    <CouponCode
                      {...props}
                      onSave={handleSaveForm}
                      defaultValues={{}}
                      curMenu={selectedItem}
                      onDirtyChange={handleDirtyChange}
                    />
                  </CustomBox>
                )}

                {/* right icon, back to product list */}
                <ProductBackLink />
              </Box>
            </Grid>
          </Grid>
        </Edit>
      </div>
    </>
  );
};

export default ProductEdit;
